/* UI e helper condivisi per le pagine Playtomic (tema chiaro Control Center). */
import { useEffect, useState } from "react";
import { ptapp, type Account } from "@/lib/ptapp";

export const MONZA = { lat: 45.5845, lon: 9.2744 };
export const COORD = `${MONZA.lat},${MONZA.lon}`;
export const T = ptapp.MOVING_TENANT;
export const ROME = "Europe/Rome";

export const esc = (s: unknown) => (s == null ? "" : String(s));

export function Avatar({ pic, size }: { pic?: string | null; size: number }) {
  if (pic) return <img src={pic} style={{ width: size, height: size }} className="rounded-full object-cover shrink-0" alt="" />;
  return <div style={{ width: size, height: size, fontSize: Math.round(size * 0.5) }} className="rounded-full bg-slate-200 flex items-center justify-center shrink-0">👤</div>;
}

export function Card({ title, children, className = "" }: { title?: string; children: React.ReactNode; className?: string }) {
  return (
    <div className={"rounded-xl border border-slate-200 bg-white p-4 shadow-sm " + className}>
      {title ? <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</h3> : null}
      {children}
    </div>
  );
}

export const Row = ({ k, v }: { k: string; v: React.ReactNode }) =>
  v || v === 0 ? <div className="flex items-center justify-between gap-3 py-0.5"><span className="text-sm text-slate-500">{k}</span><b className="text-right text-sm text-slate-900">{v}</b></div> : null;

export const Pill = ({ children, tone = "slate" }: { children: React.ReactNode; tone?: "slate" | "green" | "red" | "blue" }) => {
  const c = { slate: "bg-slate-100 text-slate-600", green: "bg-green-100 text-green-700", red: "bg-red-100 text-red-700", blue: "bg-blue-100 text-blue-700" }[tone];
  return <span className={"rounded-full px-2 py-0.5 text-xs font-medium " + c}>{children}</span>;
};

export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return <div><h2 className="mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</h2>{children}</div>;
}

/** Selettore account riusabile. */
export function AccountSelect({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const [accounts, setAccounts] = useState<Account[]>([]);
  useEffect(() => { ptapp.accounts().then(setAccounts).catch(() => {}); }, []);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className="rounded-md border border-slate-300 px-2 py-1.5 text-sm">
      {accounts.map((a) => <option key={a.key} value={a.key}>{a.name || a.email}</option>)}
    </select>
  );
}

// ── date/tempo (Playtomic usa UTC naive: convertiamo a Europe/Rome per la UI) ──
export const asUTC = (s: string) => new Date(/[zZ]$|[+\-]\d\d:?\d\d$/.test(s) ? s : s + "Z");
export const fmtDateRome = (s?: string) => {
  if (!s) return "—";
  const d = asUTC(String(s).replace(" ", "T"));
  return isNaN(+d) ? esc(s) : d.toLocaleString("it-IT", { timeZone: ROME, weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};
export const hmRome = (isoStart: string) => {
  const d = asUTC(isoStart);
  return isNaN(+d) ? String(isoStart).slice(11, 16) : d.toLocaleTimeString("it-IT", { timeZone: ROME, hour: "2-digit", minute: "2-digit" });
};
export const fmtDay = (s?: string) => { if (!s) return ""; const d = new Date(s); return isNaN(+d) ? "" : d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }); };

export const asList = (d: unknown): any[] => {
  if (Array.isArray(d)) return d;
  if (!d || typeof d !== "object") return [];
  const o = d as Record<string, unknown>;
  for (const k of ["items", "results", "data", "players", "users", "elements", "content", "tenants", "matches", "tournaments", "lessons", "classes", "courses", "rankings"]) {
    if (Array.isArray(o[k])) return o[k] as any[];
  }
  return [];
};
